/**
 * 规则选择器结果
 * 格式为: Selector(1, 2, "Id", "已选择 5 条明细，2 个规则")
 * 第一个参数为 选择器ID
 * 第二个参数为 条件(规则)ID
 * 第三个参数为 选择器返回的数据类型
 * 第四个参数为 在编辑器中显示的文案
 */

import Declaration, { DeclarationFactory } from './base';
import { ISelectorDeclaration } from '../index.d';



class SelectorDeclaration extends Declaration implements DeclarationFactory {

  public declaration = 'Selector';

  public generateRegExp() {
    return /(^Selector\(\d+\s*,\s*\d+\s*,\s*\"\w+\"\s*,\s*\".+?\"\))/;
  }

  public match(input: string): ISelectorDeclaration | undefined {
    const matched = input.match(/(^Selector\((\d+)\s*,\s*(\d+)\s*,\s*\"(\w+)\"\s*,\s*\"(.+?)\"\))/);

    if (matched) {
      const selectorId = Number(matched[2]);
      const conditionId = Number(matched[3]);
      const type = matched[4];
      const description = matched[5];

      if (!Number.isNaN(selectorId) && !Number.isNaN(conditionId)) {
        return {
          type,
          isArray: true,
          declaration: this.declaration,
          raw: matched[1],
          selectorId,
          conditionId,
          description,
          isAtom: true,
          isDeclaration: true
        };
      } else {
        throw this.generateInvalidError(matched[1], matched[2], 'Selector 格式错误');
      }
    }
  }

}


export default new SelectorDeclaration();
